import { render, staticRenderFns } from "./OrderBase.vue?vue&type=template&id=bc381282&scoped=true&"
import script from "./OrderBase.vue?vue&type=script&lang=js&"
export * from "./OrderBase.vue?vue&type=script&lang=js&"
import style0 from "./OrderBase.vue?vue&type=style&index=0&id=bc381282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc381282",
  null
  
)

export default component.exports